"use client";

import React from "react";
import { Globe, Users, Target, ChartBar, ArrowRight, ArrowDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Athlete Activity",
  icon: Globe
}, {
  title: "Intent Signals",
  icon: Users
}, {
  title: "Audience Creation",
  icon: Target
}, {
  title: "Brand Activation",
  icon: ChartBar
}];
export default function HowEsmgWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="how-it-works" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        <div className={`text-left mb-16 md:mb-24 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-primary font-default font-semibold tracking-widest uppercase text-sm md:text-base mb-3 block">HOW ESMG WORKS</span>
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tight">The Athlete Intent Engine: Real Signals. Real Audiences.</h2>
          <p className="mt-6 text-lg text-muted-foreground max-w-2xl leading-relaxed">ESMG captures first-party behavioral and intent signals across leading endurance sports publishers. These signals help identify active athlete interests and engagement, creating continuously refreshed advertising audiences for brands and media buyers.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-4 relative">
          {}
          <div className={`hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-[2px] bg-border/30 -z-10 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"}`} style={{
          transformOrigin: "left center"
        }} />

          {steps.map((step, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center relative transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 150 + 200}ms`
        }}>
              {}
              {i > 0 && <div className="md:hidden absolute -top-10 left-1/2 -translate-x-1/2 h-8 w-[2px] bg-border/30">
                  <ArrowDown className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-5 h-5 text-primary bg-background" />
                </div>}

              {}
              {i > 0 && <div className="hidden md:flex absolute top-12 left-0 -translate-x-1/2 -translate-y-1/2 bg-background w-8 h-8 items-center justify-center z-0">
                  <ArrowRight className="w-6 h-6 text-primary" />
                </div>}

              {}
              <div className="w-24 h-24 rounded-2xl border-2 border-foreground bg-background shadow-sm flex items-center justify-center mb-6 relative group hover:border-primary hover:shadow-md transition-all duration-300 z-10">
                <div className="absolute inset-0 bg-primary/5 rounded-2xl scale-0 group-hover:scale-100 transition-transform duration-300" />
                <step.icon className="w-10 h-10 text-foreground group-hover:text-primary transition-colors duration-300 relative z-10" strokeWidth={1.5} />
                {}
                <div className="absolute top-3 right-3 w-2.5 h-2.5 rounded-md bg-primary shadow-sm" />
              </div>

              {}
              <h3 className="text-lg md:text-xl font-bold font-default leading-tight max-w-[180px]">
                {step.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}